var map = {
	"./Alert.svg": 1084,
	"./access.svg": 300,
	"./add_guest.svg": 1085,
	"./arrow_disabled_left.svg": 376,
	"./arrow_disabled_right.svg": 377,
	"./arrow_down.svg": 724,
	"./arrow_down_gray.svg": 447,
	"./arrow_down_nospace.svg": 725,
	"./arrow_down_white.svg": 726,
	"./arrow_down_yellow.svg": 48,
	"./arrow_gray.svg": 334,
	"./arrow_left.svg": 299,
	"./arrow_left_gray.svg": 258,
	"./arrow_left_yellow.svg": 727,
	"./arrow_right.svg": 214,
	"./arrow_right_gray.svg": 257,
	"./arrow_right_gray_nospace.svg": 215,
	"./arrow_right_nospace.svg": 1086,
	"./arrow_up_gray.svg": 728,
	"./arrow_yellow.svg": 259,
	"./arrowleft.svg": 1087,
	"./arrowright.svg": 1088,
	"./asset-format/icon_button1_a.svg": 729,
	"./asset-format/icon_button1_b.svg": 730,
	"./asset-format/icon_button2_a.svg": 731,
	"./asset-format/icon_button2_b.svg": 732,
	"./asset-format/icon_coupon_a.svg": 733,
	"./asset-format/icon_coupon_b.svg": 734,
	"./asset-format/icon_free_a.svg": 735,
	"./asset-format/icon_free_b.svg": 736,
	"./asset-format/icon_image_a.svg": 737,
	"./asset-format/icon_image_b.svg": 738,
	"./asset-format/icon_map_a.svg": 739,
	"./asset-format/icon_map_b.svg": 740,
	"./asset-format/icon_news_a.svg": 741,
	"./asset-format/icon_news_b.svg": 742,
	"./asset-format/icon_pulldown_a.svg": 743,
	"./asset-format/icon_pulldown_b.svg": 744,
	"./asset-format/icon_request_a.svg": 745,
	"./asset-format/icon_request_b.svg": 746,
	"./asset-format/icon_space_a.svg": 747,
	"./asset-format/icon_space_b.svg": 748,
	"./back.svg": 1099,
	"./birthday.svg": 534,
	"./business.svg": 535,
	"./button_arrow_left.svg": 448,
	"./button_arrow_right.svg": 449,
	"./button_trash.svg": 1100,
	"./calendar.svg": 1101,
	"./calendar_icon.svg": 216,
	"./camera.svg": 1102,
	"./camera_icon_gray.svg": 536,
	"./camera_icon_orange.svg": 749,
	"./camera_icon_white.svg": 178,
	"./cancel.svg": 450,
	"./chanel.svg": 750,
	"./check-box.svg": 751,
	"./check-box_off.svg": 752,
	"./check-box_on.svg": 753,
	"./checkin.svg": 1103,
	"./cleaning_manager/icon_arrow_down_yellow.svg": 1104,
	"./cleaning_manager/icon_calender_arrow_left.svg": 754,
	"./cleaning_manager/icon_calender_arrow_right.svg": 755,
	"./cleaning_manager/icon_comment.svg": 378,
	"./cleaning_manager/icon_date.svg": 451,
	"./cleaning_manager/icon_instruction.svg": 234,
	"./cleaning_manager/icon_menu.svg": 1105,
	"./cleaning_manager/icon_menu_active.svg": 1106,
	"./cleaning_manager/icon_menu_black.svg": 756,
	"./cleaning_manager/icon_openall_arrow_down.svg": 757,
	"./cleaning_manager/icon_openall_arrow_up.svg": 758,
	"./cleaning_manager/icon_people.svg": 452,
	"./cleaning_manager/icon_reload.svg": 759,
	"./cleaning_manager/icon_report.svg": 1107,
	"./cleaning_manager/icon_request.svg": 1108,
	"./cleaning_manager/icon_sort.svg": 760,
	"./cleaning_manager/mobile/icon_back.svg": 761,
	"./cleaning_manager/mobile/icon_calender_arrow_left.svg": 1109,
	"./cleaning_manager/mobile/icon_calender_arrow_right.svg": 1110,
	"./cleaning_manager/mobile/icon_checkin.svg": 762,
	"./cleaning_manager/mobile/icon_date.svg": 1111,
	"./cleaning_manager/mobile/icon_people.svg": 1112,
	"./cleaning_manager/mobile/logo.svg": 763,
	"./close-camera.svg": 764,
	"./close.svg": 765,
	"./coupons_manager/icon_menu.svg": 1113,
	"./coupons_manager/icon_menu_active.svg": 1114,
	"./create.svg": 1115,
	"./csv.svg": 137,
	"./custom-design/icon_menu_hamburger.svg": 1117,
	"./custom-design/icon_pallet.svg": 766,
	"./custom-design/icon_pulldown.svg": 1118,
	"./customer-manager/icon_check.svg": 453,
	"./customer-manager/icon_check_tag.svg": 1123,
	"./customer-manager/icon_remove.svg": 1124,
	"./customer-manager/icon_tag.svg": 1125,
	"./customer-search.svg": 767,
	"./dashboard/check-out_image.svg": 1126,
	"./dashboard/checkin.svg": 768,
	"./dashboard/checkout.svg": 769,
	"./dashboard/nps_arrow.svg": 1127,
	"./dashboard/nps_image_base.svg": 1128,
	"./dashboard/nps_image_none.svg": 1129,
	"./dashboard/reservation.svg": 770,
	"./dashboard/stay.svg": 771,
	"./date.svg": 537,
	"./deleat.svg": 772,
	"./deleat_icon.svg": 301,
	"./delete.svg": 1130,
	"./delete_black.svg": 773,
	"./delete_gray.svg": 1131,
	"./delete_orange.svg": 161,
	"./delete_white.svg": 774,
	"./delete_yellow.svg": 179,
	"./delivery.svg": 538,
	"./download.svg": 539,
	"./download_white.svg": 775,
	"./eat.svg": 777,
	"./edit.svg": 235,
	"./edit_icon.svg": 1132,
	"./edit_no_margin.svg": 454,
	"./edit_window.svg": 540,
	"./evaluation.svg": 1133,
	"./file_download.svg": 778,
	"./guest.svg": 1136,
	"./header/aipass.svg": 1137,
	"./header/aipassLogo.svg": 532,
	"./header/another_tab.svg": 1138,
	"./header/attention.svg": 1139,
	"./header/button_arrow_down.svg": 531,
	"./header/data-correction-icon-final.svg": 723,
	"./header/help.svg": 722,
	"./header/hotel.svg": 530,
	"./header/ic_play_arrow_24px.svg": 1140,
	"./header/icon_form_edit.svg": 1141,
	"./header/icon_logout.svg": 533,
	"./header/language.svg": 779,
	"./header/news.svg": 716,
	"./header/news_attention.svg": 717,
	"./header/search.svg": 1142,
	"./header/setting.svg": 721,
	"./header/tab_open_hover.svg": 1143,
	"./health-check.svg": 1144,
	"./help.svg": 379,
	"./hotel.svg": 780,
	"./icon-hover.svg": 1146,
	"./icon/logo.svg": 245,
	"./icon_arrow_down.svg": 1147,
	"./icon_arrow_down_2.svg": 302,
	"./icon_arrow_left.svg": 781,
	"./icon_arrow_right.svg": 782,
	"./icon_arrow_up.svg": 1148,
	"./icon_arrow_up_2.svg": 180,
	"./icon_button1.svg": 783,
	"./icon_caalender_left.svg": 100,
	"./icon_caalender_right.svg": 95,
	"./icon_calculator.svg": 1149,
	"./icon_calculator_active.svg": 1150,
	"./icon_calender.svg": 1151,
	"./icon_checkin.svg": 784,
	"./icon_checkin2.svg": 1152,
	"./icon_checkin_active.svg": 1153,
	"./icon_checkin_orange.svg": 455,
	"./icon_checkout.svg": 1154,
	"./icon_checkout_active.svg": 1155,
	"./icon_checkout_black.svg": 785,
	"./icon_clip.svg": 1156,
	"./icon_customer.svg": 1157,
	"./icon_customer_active.svg": 1158,
	"./icon_dashboard.svg": 1159,
	"./icon_dashboard_active.svg": 1160,
	"./icon_delete.svg": 541,
	"./icon_delete2.svg": 542,
	"./icon_delete2_warning.svg": 786,
	"./icon_delete_warning.svg": 543,
	"./icon_down.svg": 544,
	"./icon_down_gray.svg": 1161,
	"./icon_eye_off.svg": 380,
	"./icon_eye_on.svg": 381,
	"./icon_file.svg": 787,
	"./icon_filter_active.svg": 335,
	"./icon_filter_disable.svg": 336,
	"./icon_h1.svg": 788,
	"./icon_h2.svg": 789,
	"./icon_help.svg": 545,
	"./icon_hotel_notice.svg": 790,
	"./icon_keep.svg": 546,
	"./icon_list.svg": 547,
	"./icon_logo.svg": 791,
	"./icon_map_black.svg": 792,
	"./icon_menu_invoice.svg": 1162,
	"./icon_menu_invoice_active.svg": 1163,
	"./icon_more_view_arrow.svg": 548,
	"./icon_other.svg": 303,
	"./icon_plan_name.svg": 1164,
	"./icon_reservation.svg": 1165,
	"./icon_reservation_active.svg": 1166,
	"./icon_reservation_copy.svg": 793,
	"./icon_room.svg": 794,
	"./icon_schedule.svg": 1167,
	"./icon_schedule_disable.svg": 795,
	"./icon_star_f.svg": 456,
	"./icon_star_n.svg": 457,
	"./icon_stay.svg": 1168,
	"./icon_stay_active.svg": 1169,
	"./icon_sync.svg": 1170,
	"./icon_sync_alt.svg": 1171,
	"./icon_up.svg": 549,
	"./icon_up_gray.svg": 1172,
	"./icon_warning.svg": 796,
	"./icon_wrench.svg": 1174,
	"./identification.svg": 797,
	"./identification_card_back.svg": 1175,
	"./identification_card_front.svg": 1176,
	"./image_ng.svg": 798,
	"./image_ok.svg": 799,
	"./input.svg": 1177,
	"./language-arrow.svg": 1178,
	"./language.svg": 1179,
	"./license.svg": 1180,
	"./license_01.svg": 1181,
	"./license_02.svg": 1182,
	"./link_add.svg": 550,
	"./link_add_hover.svg": 1183,
	"./link_add_normal.svg": 1184,
	"./link_add_orange.svg": 800,
	"./link_deleat.svg": 1185,
	"./link_deleat_hover.svg": 1186,
	"./list_sort_arrow.svg": 1187,
	"./list_sort_arrow_active.svg": 1188,
	"./magnify.svg": 551,
	"./magnifying_glass.svg": 801,
	"./mail-delivery/arrow-right.svg": 802,
	"./mail-delivery/form_delete.svg": 552,
	"./mail-delivery/icon_menu.svg": 1189,
	"./mail-delivery/icon_menu_active.svg": 1190,
	"./mail.svg": 304,
	"./man.svg": 1193,
	"./memo.svg": 382,
	"./miwa-lock/close_gray.svg": 1194,
	"./miwa-lock/key_gray.svg": 1195,
	"./miwa-lock/key_green.svg": 1196,
	"./miwa-lock/miwa_card_read_close.svg": 719,
	"./miwa-lock/miwa_card_read_error.svg": 720,
	"./miwa-lock/miwa_deleat_icon.svg": 803,
	"./miwa-lock/miwa_image.svg": 804,
	"./mobile-menu/icon_checkin.svg": 805,
	"./mobile-menu/icon_clean.svg": 1197,
	"./mobile_logo.svg": 806,
	"./mobile_request/add.svg": 260,
	"./mobile_request/csv_up.svg": 1198,
	"./mobile_request/csv_up_hover.svg": 1199,
	"./mobile_request/csv_up_orange.svg": 1200,
	"./mobile_request/delete.svg": 1201,
	"./mobile_request/delete_orange.svg": 553,
	"./mobile_request/request_icon.svg": 1202,
	"./mobile_request/request_icon_active.svg": 1203,
	"./nationality.svg": 554,
	"./new_identification_card_back.svg": 555,
	"./new_identification_card_front.svg": 556,
	"./new_reservation.svg": 557,
	"./news.svg": 1204,
	"./notice/attention.svg": 1205,
	"./notice/checkin.svg": 1206,
	"./notice/checkout.svg": 1207,
	"./notice/stay.svg": 1208,
	"./nps_down.svg": 1209,
	"./nps_up.svg": 1210,
	"./numberofpeople.svg": 807,
	"./operation-log/icon_menu.svg": 808,
	"./operation-log/icon_menu_active.svg": 1211,
	"./passport_guide_white.svg": 809,
	"./pay.svg": 810,
	"./people.svg": 811,
	"./phone.svg": 337,
	"./picture.svg": 558,
	"./plan.svg": 812,
	"./plus-white.svg": 236,
	"./plus.svg": 181,
	"./plus_gray.svg": 559,
	"./plus_yellow.svg": 162,
	"./pos_image.svg": 813,
	"./powered_by_aipass.svg": 1213,
	"./poweredby.svg": 1214,
	"./poweredby_logo.svg": 1215,
	"./poweredbyaipass.svg": 1216,
	"./previous-night.svg": 814,
	"./qr-check.svg": 1217,
	"./radio_disabled.svg": 560,
	"./radio_off.svg": 561,
	"./radio_on.svg": 562,
	"./reload.svg": 446,
	"./repeater-icon.svg": 815,
	"./reports_manager/icon_menu.svg": 1219,
	"./reports_manager/icon_menu_active.svg": 1220,
	"./reservation-note/icon_cleaning.svg": 261,
	"./reservation-note/icon_front.svg": 383,
	"./reservation-note/icon_meal.svg": 384,
	"./reservation-note/icon_meal_active.svg": 816,
	"./room-rate/color-check.svg": 563,
	"./room/add.svg": 817,
	"./room/check-box_gray_on.svg": 458,
	"./room/check-box_off.svg": 459,
	"./room/check-box_on.svg": 564,
	"./room/check-box_parent.svg": 565,
	"./room/check-box_yellow_on.svg": 460,
	"./room/preparation.svg": 818,
	"./room/preparation_white.svg": 819,
	"./room/room.svg": 820,
	"./room/room_active.svg": 821,
	"./room/select.svg": 822,
	"./room/settle_gray.svg": 461,
	"./room/settle_orange.svg": 298,
	"./room/settle_white.svg": 462,
	"./room_delete.svg": 1227,
	"./room_delete_gold.svg": 262,
	"./room_manager_arrow.svg": 566,
	"./room_manager_arrow_left.svg": 823,
	"./scan.svg": 567,
	"./search.svg": 1228,
	"./segment-icon3.svg": 824,
	"./select.svg": 99,
	"./select_gray.svg": 217,
	"./select_gray_up.svg": 1229,
	"./select_white.svg": 568,
	"./self-checkin-payment/arrow.svg": 233,
	"./self-checkin-payment/language.svg": 718,
	"./self-checkin-payment/terminal/icon_check.svg": 826,
	"./self-checkin-payment/terminal/icon_ng.svg": 463,
	"./self-checkin/complete-image.svg": 834,
	"./self-checkin/drivers-license-back-sample.svg": 835,
	"./self-checkin/drivers-license-front-sample.svg": 836,
	"./self-checkin/icon_captured_check.svg": 837,
	"./self-checkin/icon_check.svg": 1233,
	"./self-checkin/icon_check_border.svg": 838,
	"./self-checkin/icon_down.svg": 1234,
	"./self-checkin/icon_non.svg": 1235,
	"./self-checkin/icon_up.svg": 1236,
	"./self-checkin/my-number-card-front-sample.svg": 839,
	"./self-checkin/residence-card-back-sample.svg": 840,
	"./self-checkin/residence-card-front-sample.svg": 841,
	"./self-checkin/welcome.svg": 1237,
	"./space/help_info.svg": 842,
	"./space/help_time.svg": 843,
	"./space_manager/arrow_left.svg": 844,
	"./space_manager/space_icon.svg": 1238,
	"./space_manager/space_icon_active.svg": 1239,
	"./stay.svg": 845,
	"./surveys/icon_menu.svg": 1240,
	"./surveys/icon_menu_active.svg": 1241,
	"./tab_reservation.svg": 1243,
	"./tab_reservation_active.svg": 1244,
	"./tag.svg": 1246,
	"./tell.svg": 572,
	"./textediter_bold.svg": 573,
	"./textediter_bold_active.svg": 846,
	"./textediter_link.svg": 574,
	"./textediter_link_active.svg": 1247,
	"./textediter_list.svg": 575,
	"./textediter_list_active.svg": 847,
	"./textediter_numberlist.svg": 576,
	"./textediter_numberlist_active.svg": 848,
	"./textediter_title.svg": 849,
	"./textediter_title_active.svg": 850,
	"./textediter_title_en.svg": 851,
	"./textediter_title_en_active.svg": 852,
	"./textediter_underline.svg": 577,
	"./textediter_underline_active.svg": 853,
	"./textediter_video.svg": 854,
	"./upload.svg": 1250,
	"./upload_white.svg": 1251,
	"./user.svg": 263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2109;